import { getAppChatApi, getChatApi, getChatPersonalizationApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { ChatApiGetChatDialogsRequest, ChatDialogResponse } from '@/core/generated/api';

/** Управляет личными закреплениями сотрудника в доступных каналах */
export const operatorChatPinService = {
    /** Загружает все закрепления с текущими условиями поиска */
    async getPinned(
        native: boolean,
        query: ChatApiGetChatDialogsRequest
    ): Promise<ChatDialogResponse[]> {
        try {
            const dialogs: ChatDialogResponse[] = [];
            let offset = 0;

            while (true) {
                const request = {
                    ...query,
                    pinnedOnly: true,
                    offset,
                    limit: 100
                };

                const response = native
                    ? await getAppChatApi().getAppChats(request)
                    : await getChatApi().getChatDialogs(request);

                dialogs.push(...response.data.items ?? []);
                const next = response.data.nextOffset;

                if (next == null) return dialogs;
                if (next <= offset) throw new Error('Не удалось загрузить закреплённые диалоги');
                offset = next;
            }
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Изменяет закрепление только для текущего сотрудника */
    async setPin(dialog: ChatDialogResponse, pinned: boolean): Promise<void> {
        if (!dialog.id) return;

        try {
            const request = {
                dialogId: dialog.id,
                pinChatRequest: { isPinned: pinned }
            };

            if (dialog.channel?.id === 'vox') {
                await getChatPersonalizationApi().setOperatorAppChatPin(request);
            } else {
                await getChatPersonalizationApi().setOperatorExternalChatPin(request);
            }
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
